import ValueProgressIndicator from "./ValueProgressIndicator";

export default ValueProgressIndicator;
